module.exports = __webpack_public_path__ + "static/media/algoritmo1.aa597fdb.png";